<template>
  <div style="max-width: 100%" id="menu-bar-id" :class="scrollPosition > 0 ? 'header-bg' : 'header-bg-transparent'">
    <b-navbar type="light" variant="light" :class="scrollPosition > 0 ? 'no-fixed-bar' : 'fixed-bar'">
      <b-container>
        <b-navbar-brand><span>
            <Icon icon="mdi:phone-outline" style="
                              color: #000;
                              width: 1.5rem;
                              height: 1.5rem;
                              margin-right: 0.3rem;
                            " />
          </span><span style="color: black">+55 (65) 3613-0088</span></b-navbar-brand>
        <b-navbar-nav>
          <b-nav-item href="" @click.prevent="setLocale('en')">
            <img class="m-1" src="@/assets/img/Flag_en.svg" style="max-height: 2rem" /></b-nav-item>
          <b-nav-item href="" @click.prevent="setLocale('pt-br')">
            <img class="m-1" src="@/assets/img/Flag_br.svg" style="max-height: 2.2rem" /></b-nav-item>
        </b-navbar-nav>
      </b-container>
    </b-navbar>
    <div style="position: relative;" :class="scrollPosition > 0 ? 'menu-bar-items-curto' : 'menu-bar-items'">
      <div style="" :class="scrollPosition > 0 ? 'header-bg' : 'header-bg-transparent__div'"></div>
      <div :class="scrollPosition > 0 ? 'painel-menu-bar-curto w-100' : 'painel-menu-bar w-100'">
        <b-container xl class="bg-transparent">
          <b-navbar toggleable="lg" class="bg-transparent pr-0 pl-0">
            <b-navbar-brand href="#home">
              <b-img-lazy :height="logoHeight" class="img-logo" :src="logoInvest" />
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto">
                <b-nav-item href="#home"><span
                    :class="scrollPosition > 0 ? 'text-menu-home ml-2 menu-bar-item-dark' : 'text-info ml-2 menu-bar-item-light'">Home</span></b-nav-item>
                <b-nav-item href="#pq-investir-em-mt"><span
                    :class="scrollPosition > 0 ? 'text-dark ml-2 menu-bar-item-dark' : 'text-menu-white ml-2 menu-bar-item-light'">{{
                      $t("nav.invest") }}</span>
                </b-nav-item>
                <b-nav-item href="#oportunidades"><span
                    :class="scrollPosition > 0 ? 'text-menu-oportunidades ml-2 menu-bar-item-dark' : 'text-warning ml-2 menu-bar-item-light'">{{
                      $t("nav.oportunidades")
                    }}</span></b-nav-item>
                <b-nav-item href="#incentivos"><span
                    :class="scrollPosition > 0 ? 'text-dark ml-2 menu-bar-item-dark' : 'text-menu-white ml-2 menu-bar-item-light'">{{
                      $t("nav.incentivos")
                    }}</span></b-nav-item>
                <!-- <b-nav-item href="#eventos"><span
                    :class="scrollPosition > 0 ? 'text-dark ml-2 menu-bar-item-dark' : 'text-menu-white ml-2 menu-bar-item-light'">{{
                      $t("nav.eventos")
                    }}</span></b-nav-item> -->
                <b-nav-item href="#trabalhe-consco"><span
                    :class="scrollPosition > 0 ? 'text-dark ml-2 menu-bar-item-dark' : 'text-menu-white ml-2 menu-bar-item-light'">{{
                      $t("nav.trabalheConosco")
                    }}</span></b-nav-item>
                <b-nav-item href="#contatos"><span
                    :class="scrollPosition > 0 ? 'text-dark ml-2 menu-bar-item-dark' : 'text-menu-white ml-2 menu-bar-item-light'">{{
                      $t("nav.contato")
                    }}</span></b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </b-container>
      </div>

    </div>

  </div>
</template>

<script>
import LogoInvestTextoBranco from "@/assets/img/logo-invest-com-texto-branco.svg";
import LogoInvestTextoPreto from "@/assets/img/logo-invest-com-texto-preto.svg";
import { Icon } from "@iconify/vue2";

export default {
  name: "MenuBarInvest",
  components: {
    Icon,
  },
  data: function () {
    return {
      scrollPosition: 0,
    };
  },
  computed: {
    logoInvest() {
      return this.scrollPosition > 0
        ? LogoInvestTextoPreto
        : LogoInvestTextoBranco;
    },
    logoHeight() {
      return this.scrollPosition > 0 ? 40 : 50;
    },
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    integerFormat(number) {
      return number.toFixed(0);
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      this.$router.push({
        params: { lang: locale },
      });
      this.$router.go(0);
    },
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  },
};
</script>

<style scoped>
#menu-bar-id {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
}

.header-bg-transparent__div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  min-height: 80px;
}

.header-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  min-height: 70px;
  background-color: var(--bg-header-cinza);
  transition: ease-in-out 0.3s;
}

.no-fixed-bar {
  height: 0;
  position: absolute;
  visibility: hidden;
}

.fixed-bar {
  height: 2.70rem;
  transition: ease 0.3s;
}

.menu-a-direita {
  margin-left: auto;
}

.img-logo {
  max-height: 50px;
  transition: ease-in-out 0.5s;
}

.menu-bar-items {
  font-weight: bold;
  font-size: 1.2rem;
  min-height: 80px;
}

.menu-bar-items-curto {
  font-weight: bold;
  font-size: 1.2rem;
  min-height: 70px;
}

.menu-bar-item-dark:hover {
  border-radius: 8px;
  background-color: black;
  padding: 5px 10px;
  transition: ease-in-out 0.3s;
  color: white !important;
}

.menu-bar-item-light:hover {
  border-radius: 8px;
  background-color: var(--bg-header-cinza);
  padding: 5px 10px;
  transition: ease-in-out 0.3s;
  color: black !important;
}

.text-menu-home {
  color: #148b9b;
}

.text-info.menu-bar-item-light:hover {
  color: #148b9b !important;
}

.text-menu-home.menu-bar-item-dark:hover {
  background-color: #148b9b;
  color: white;
}



.text-menu-oportunidades {
  color: #d39d08;
}

.text-menu-oportunidades.menu-bar-item-dark:hover {
  background-color: #d39d08;
  color: white;
}

.text-warning.menu-bar-item-light:hover {
  color: #d39d08 !important;
}


.text-menu-white {
  color: white;
}

.painel-menu-bar {
  position: absolute;
  top: 0;
  left: 0;
  border-bottom: 1px solid white;
  min-height: 80px;
  background-color: rgb(86, 86, 86, 0.7);
}

.painel-menu-bar-curto {
  position: absolute;
  top: 0;
  left: 0;
  border-bottom: 1px solid white;
  min-height: 70px;
  background-color: white;
}

@media only screen and (max-width: 1200px) {
  .header-bg-transparent__div {
    height: auto;
  }

  .header-bg {
    height: auto;
  }
}</style>
